<div class="text-center pt-4">
    <!-- Process Page Design -->
    <div class="pix_deposit_processing_logo"></div>
    <p class="pix-status-txt font-weight-bold mt-3 mb-2 loading-ellipsis">
        {{ 'PARTY.CASHIER.web.deposit.bankregistration.qrcode.generator.processing.txt' | translate }}
    </p>
    <p class="m-0 font-weight-bold mb-4">
        {{
            'PARTY.CASHIER.web.deposit.bankregistration.qrcode.generator.processing.amount'
                | translate: { processingamount: processingAmount() | vnCurrency }
        }}
    </p>
    <p class="m-0 fs-14">{{ 'PARTY.CASHIER.web.deposit.bankregistration.qrcode.generator.processing.time' | translate }}</p>
    <p class="m-0 font-weight-bold fs-14">
        {{ 'PARTY.CASHIER.web.deposit.bankregistration.qrcode.generator.processing.sla' | translate: { time: processingTime } }}
    </p>
    <div
        class="limit-reach-content text-left my-3"
        [vnDynamicHtml]="'PARTY.CASHIER.web.deposit.bankregistration.qrcode.generator.processing.msg' | translate: { brandId: brandId() }"></div>
</div>
